import { defer, LoaderFunction } from 'react-router-dom'

import { PaginatedResponse } from '@custom-types/response'
import Score from '@models/Score'
import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'

export type DeletedScoresResponse = {
  scores: Score[]
} & PaginatedResponse

export type DeletedScoresLoaderResponse = {
  deletedScores: Promise<DeletedScoresResponse>
  order: string | null
}

export const DELETED_PAGE_SIZE = 15

const deletedScoresLoader: LoaderFunction = async ({ request }) => {
  const url = new URL(request.url)

  const order = url.searchParams.get('order')
  const deletedScores = http.loader.post(ApiRoutes.members.trashPath(), {
    order,
    max_count: DELETED_PAGE_SIZE,
  })
  return defer({ deletedScores, order })
}

export default deletedScoresLoader
